import { apiAgent } from "../config/axiosConfig";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const appConfig = createAsyncThunk(
  "appConfig",
  async ({ dispatch, rejectWithValue }) => {
    try {
      const res = await apiAgent({
        method: "get",
        url: "/api/v1/app_config",
      });
      if (res.status === 200) {
        return res.data;
      } else {
        return rejectWithValue(res.data);
      }
    } catch (err) {
      return rejectWithValue(err.response ? err.response.data : err.message);
    }
  }
);
